export const ONEDU = 'onEDU';
export const TOKEN = `${ONEDU}Token`;
export const EMAIL = `${ONEDU}Email`;
export const I18N = `${ONEDU}I18n`;
export const I18N_LNG = `${ONEDU}I18Lng`;
export const REMEMBER_ME = `${ONEDU}RemenberMe`;
export const PERSIST = `persist:${ONEDU}`;
export const APP_VERSIOM = `1.0.6`;
export const APP_NAME = `On EDU`;
